import { render, staticRenderFns } from "./AffiliateUserIcon.vue?vue&type=template&id=722281ea&scoped=true"
import script from "./AffiliateUserIcon.vue?vue&type=script&lang=js"
export * from "./AffiliateUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722281ea",
  null
  
)

export default component.exports